import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ReportesEstablecimientosService } from "./reportes-establecimientos.service";
import { MunicipioEntry } from "src/app/shared/entrys/municipio.entry";
import { AuthService } from "./../../../../../../../shared/services/auth.service";
import {
  FormGroup,
  FormBuilder,
  FormArray,
  FormControl,
  ValidatorFn,
} from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { EstablecimientoComercioService } from "../../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { DepartamentoEntry } from "src/app/shared/entrys/departamento.entry";
import { CampoAdicionalCategoriaService } from "../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service";
import { DocumentoSubcategoriaService } from "../../configuracion/documento-subcategoria/documento-subcategoria.service";
import { AccionRntService } from "../../configuracion/accion-rnt/accion-rnt.service";
import { ModuloAyudaService } from "../../configuracion/modulo-ayuda/modulo-ayuda.service";
// tslint:disable-next-line:max-line-length
import { ModalSeleccionFuncionarioComponent } from "src/app/components/core/layouts/modal-seleccion-funcionario/modal-seleccion-funcionario.component";
import { CompletaInformacionService } from "../../../prestador/pasos/completa-informacion/completa-informacion.service";
import { HttpEventType } from "@angular/common/http";
import * as FileSaver from "file-saver";

@Component({
  // tslint:disable-next-line:indent
  selector: "app-reportes-establecimientos",
  // tslint:disable-next-line:indent
  templateUrl: "./reportes-establecimientos.component.html",
  // tslint:disable-next-line:indent
  styleUrls: ["./reportes-establecimientos.component.scss"],
})
export class ReportesEstablecimientosComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerTabla: Array<string>;
  formUsuario: FormGroup;
  selectUsuario: any;
  camarasLista: Array<CamaraComercioEntry>;
  paginaActual: number;
  adminSuper = RolesUsuario.AdministradorSuper;
  prestador = RolesUsuario.Prestador;
  adminCC = RolesUsuario.AdministradorCC;
  columnas: Array<any> = [];
  columnasEnvio: any;
  // filtros
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = true;
  isExportar = true;
  camaraComercio: string;
  // Selects
  categoria: Array<any> = [];
  subcategoria: Array<any> = [];
  estadoRnt: Array<any> = [];
  tipoRNT: Array<any> = [];
  departamento: Array<DepartamentoEntry> = [];
  municipio: Array<MunicipioEntry> = [];
  exportarForm: FormGroup;
  exportarList = [
    { id: "Descripcion_Camara", name: "Cámara de Comercio" },
    { id: "Descripcion_Departamento", name: "Departamento" },
    { id: "Descripcion_Municipio", name: "Municipio" },
    { id: "Nombre_Funcionario", name: "Funcionario" },
    { id: "Descripcion_Categoria", name: "Categoría" },
    { id: "Descripcion_Subcategoria", name: "Subcategoría" },
    { id: "Descripcion_Tipo_Rnt", name: "Tipo Rnt" },
    { id: "Codigo_Rnt", name: "Número Rnt" },
    { id: "Descripcion_Estado_Rnt", name: "Estado Rnt" },
    { id: "Numero_Radicado", name: "Número Radicado" },
    { id: "Numero_Identificacion", name: "Nit" },
    { id: "Razon_Social", name: "Nombre o Razón social" },
    { id: "Matricula", name: "Número Matrícula" },
    { id: "Fecha_Matricula", name: "Fecha Matrícula" },
    { id: "Fecha_Renovacion_Matricula", name: "Fecha Renovación Matrícula" },
    { id: "Fecha_Renovacion_Rnt", name: "Fecha Renovación Rnt" },
    { id: "Nombre_Gerente", name: "Nombre Gerente" },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private reportesEstablecimientos: ReportesEstablecimientosService,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService,
    private basicasLoVService: BasicasLoVService,
    private categoriaService: CampoAdicionalCategoriaService,
    private subcategoriaService: DocumentoSubcategoriaService,
    private estadoRntService: AccionRntService,
    private tipoRntService: ModuloAyudaService,
    private modalService: NgbModal,
    private subCategoriaxCategoriaService: CompletaInformacionService
  ) {
    this.createPagingTable();
    this.createForm();

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(
      (control) => new FormControl(false)
    );
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl,
    });

    this.selectUsuario = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.titleTable();
    this.onCamaraSelect();
    this.onDepartamentosSelect();
    this.onMunicipioSelect();
    this.onCategoriaSelect();
    this.onSubcategoriaSelect();
    this.onEstadoRNTSelect();
    this.onTipoRNTSelect();
    this.onChanges();
  }

  createForm() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      codigo_departamento: [null],
      municipio_id: [null],
      usuario: [null],
      usuario_id: [null],
      categoria: [null],
      sub_categoria: [null],
      tipo_rnt: [null],
      codigo_rnt: [null],
      estado_rnt: [null],
      numero_radicado: [null],
      numero_identificacion: [null],
      razon_social: [null],
      matricula: [null],
    });

    this.formCheck = this.formBuilder.group({
      orders: new FormArray([]),
    });
  }

  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
  }

  onConsultarEstablecimientos(page: number) {
    this.reportesEstablecimientos
      .getDataTable({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarEstablecimientos(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarEstablecimientos(1);
  }

  limpiar() {
    this.filtro.reset();
    this.createPagingTable();
    this.onCamaraSelect();
    this.onDepartamentosSelect();
    this.onMunicipioSelect();
    this.onCategoriaSelect();
    this.onSubcategoriaSelect();
    this.onEstadoRNTSelect();
    this.onTipoRNTSelect();
    this.onChanges();
  }

  titleTable() {
    this.headerTabla = [
      "Cámara de comercio",
      "Departamento",
      "Municipio",
      "Funcionario",
      "Categoría",
      "Subcategoría",
      "Tipo RNT",
      "Número RNT",
      "Estado RNT",
      "Número Radicado",
      "Nit",
      "Nombre o Razón social",
      "Número Matrícula",
      "Fecha Matrícula",
      "Fecha Renovación Matrícula",
      "Fecha Renovación RNT",
      "Nombre gerente",
    ];
  }

  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.filtro
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.onDepartamentosSelect();
        }
      }
    });
  }

  onDepartamentosSelect() {
    if (this.filtro.value.codigo_camara == null) {
      this.basicasLoVService.getDepartamentos(null).subscribe((resultado) => {
        if (resultado.result) {
          this.departamento = resultado.data as Array<DepartamentoEntry>;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getDepartamento({ codigo_camara: this.filtro.value.codigo_camara })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.departamento = resultado.data as Array<DepartamentoEntry>;
            this.onMunicipioSelect();
          }
        });
    }
  }

  onMunicipioSelect() {
    // tslint:disable-next-line:triple-equals
    if (
      this.filtro.value.codigo_camara == null &&
      this.filtro.value.codigo_departamento == null
    ) {
      this.basicasLoVService.getMunicipios(null).subscribe((resultado) => {
        if (resultado.result) {
          this.municipio = resultado.data as Array<MunicipioEntry>;
        }
      });
    } else {
      // tslint:disable-next-line:max-line-length
      this.reportesEstablecimientos
        .getMunicipio({
          codigo_camara: this.filtro.value.codigo_camara,
          departamento_id: this.filtro.value.codigo_departamento,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.municipio = resultado.data as Array<MunicipioEntry>;
          }
        });
    }
  }

  onCategoriaSelect() {
    this.categoriaService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });
  }

  onSubcategoriaSelect() {
    // tslint:disable-next-line:triple-equals
    if (this.filtro.value.categoria == null) {
      this.subcategoriaService.getSubCategoria().subscribe((resultado) => {
        if (resultado.result) {
          this.subcategoria = resultado.data;
        }
      });
    } else {
      this.reportesEstablecimientos
        .getSubcategoriasXCategoria(this.filtro.value.categoria)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.subcategoria = resultado.data;
          }
        });
    }
  }

  onEstadoRNTSelect() {
    this.estadoRntService.getEstadosRNT().subscribe((resultado) => {
      if (resultado.result) {
        this.estadoRnt = resultado.data;
      }
    });
  }

  onTipoRNTSelect() {
    this.tipoRntService.getTipoRnt().subscribe((resultado) => {
      if (resultado.result) {
        this.tipoRNT = resultado.data;
      }
    });
  }

  onChanges() {
    this.exportarForm.get("selectAll").valueChanges.subscribe((bool) => {
      this.exportarForm
        .get("exportarList")
        .patchValue(Array(this.exportarList.length).fill(bool), {
          emitEvent: false,
        });
    });

    this.exportarForm.get("exportarList").valueChanges.subscribe((val) => {
      const allSelected = val.every((bool) => bool);
      if (this.exportarForm.get("selecAll").value !== allSelected) {
        this.exportarForm
          .get("selectAll")
          .patchValue(allSelected, { emitEvent: false });
      }
    });
  }

  minSelectCheckbox(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map((control) => control.value)
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }

  submit() {
    const selectedPreferences = this.exportarForm.value.exportarList
      .map((checked, index) => (checked ? this.exportarList[index].id : null))
      .filter((value) => value !== null);

    this.columnasEnvio = selectedPreferences.join();

    this.reportesEstablecimientos
      .generarExportarEstablecimiento({
        ...this.filtro.value,
        columnas: this.columnasEnvio,
      })
      .subscribe((resultado) => {
        if (resultado.type === HttpEventType.Response) {
          if (resultado.ok) {
            this.saveAsExcelFile(
              resultado.body,
              `reporte_establecimientos.xlsx`
            );
          }
        }
      });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }

  onOpenModalStatus() {
    const modalRef = this.modalService.open(
      ModalSeleccionFuncionarioComponent,
      {
        centered: true,
        size: "lg",
        backdropClass: "light-blue-backdrop",
        windowClass: "modal-xl",
      }
    );
    modalRef.result
      .then((resultado) => {
        this.filtro.get("usuario").patchValue(resultado.usuario);
        this.filtro.get("usuario_id").patchValue(resultado.usuario_id);
      })
      .catch((resultado) => {
        this.filtro.get("usuario").patchValue(resultado.usuario);
        this.filtro.get("usuario_id").patchValue(null);
      });
    // modalRef.componentInstance.codigo_camara_shared = this.filtro.value.codigo_camara;
    // modalRef.componentInstance.desc_camara_shared = this.filtro.value.desc_camara;
  }
}
